export default function loadDiagnosticLabelsPreview() {
    /** @type {NodeListOf<HTMLElement>} */
    const diagPreviews = document.querySelectorAll('.diagPreview');
    diagPreviews.forEach(function (diagPrev) {
        const wrapper = document.createElement('div');
        const valueParagraph = document.createElement('p');
        const value = diagPrev.getAttribute('data-value');

        wrapper.classList.add('diagPreview__wrapper');
        valueParagraph.classList.add('diagPreview__value');

        if (value == '-1') {
            diagPrev.classList.add('noValue');
            valueParagraph.innerText = 'DPE vierge';
        } else if (value == '-2') {
            diagPrev.classList.add('noValue');
            valueParagraph.innerText = 'Non soumis au DPE';
        } else {
            valueParagraph.innerText = diagPrev.getAttribute('data-value') + ' ' + diagPrev.getAttribute('data-unit');
        }

        ['A', 'B', 'C', 'D', 'E', 'F', 'G'].forEach(function (letter) {
            var letterEl = document.createElement('span');
            letterEl.classList.add('diagPreview__class');
            letterEl.setAttribute('data-class', letter);
            if (letter == diagPrev.getAttribute('data-current-class')) {
                letterEl.innerText = letter;
                letterEl.classList.add('current');
            }
            wrapper.appendChild(letterEl);
        });

        diagPrev.appendChild(wrapper);
        diagPrev.appendChild(valueParagraph);
    });
}